export {default} from 'views/Symbols/Symbols'


// WEBPACK FOOTER //
// ./src/views/Administration/Symbols.jsx